import { Injectable } from '@angular/core'
import { Actions, Effect, ofType } from '@ngrx/effects'
import { Toaster } from '@tokeet-frontend/tv3-platform'
import { catchError, concatMap, map, switchMap, tap } from 'rxjs/operators'
import { of } from 'rxjs'
import { TiketChannelService } from './service'
import { ActionFailed } from '@tokeet-frontend/tv3-platform'
import { ConnectTiket, ConnectTiketSuccess, GetTiketStatus, GetTiketStatusSuccess } from './actions'

@Injectable()
export class TiketChannelEffects {
  @Effect()
  getStatus$ = this.actions$.pipe(
    ofType(GetTiketStatus),
    switchMap(() =>
      this.channelsService.getStatus().pipe(
        map((status) => GetTiketStatusSuccess({ status })),
        catchError((err) => of(ActionFailed({ error: err })))
      )
    )
  )

  @Effect()
  connect$ = this.actions$.pipe(
    ofType(ConnectTiket),
    concatMap(({ hotelId }) =>
      this.channelsService.connect(hotelId).pipe(
        tap(() => this.toaster.success($localize`Tiket connected successfully`)),
        map((status) => ConnectTiketSuccess({ status })),
        catchError((err) => of(ActionFailed({ error: err })))
      )
    )
  )

  constructor(private actions$: Actions, private channelsService: TiketChannelService, private toaster: Toaster) {}
}
